export default __webpack_public_path__ + "static/media/louki_hover.2547fa25.png";